import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { PaginationButtons } from 'src/components'
import { useRemoveImpactPeriods, useUpdateImpactPeriodsOrder } from 'src/hooks'

import { ImpactPeriodCard } from './impact-period-card.component'
import { AddImpactPeriodButton } from '../add-impact-period-button.component'
import { IImpactPeriodBaseWithId } from 'src/types'
import { IFilter } from 'src/components/filter/types/filter.types'

import { createDndHandler } from 'src/common/utils'

import { useStyles } from '../styles'

interface IImpactPeriodsGridProps {
  items?: IImpactPeriodBaseWithId[] | void
  filter: IFilter
}

const ImpactPeriodsGrid = ({ items, filter }: IImpactPeriodsGridProps) => {
  const { mutate: remove } = useRemoveImpactPeriods()
  const { mutate: changeOrder, isLoading } = useUpdateImpactPeriodsOrder()
  const classes = useStyles()

  const handleDelete = (id: string) => async () => {
    remove([id])
  }

  const { handleDragEnd } = createDndHandler({
    ids: items?.map((item) => item.id) ?? [],
    changeOrder,
  })

  return (
    <>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="impact-periods-list">
          {(provided) => (
            <div
              className={classes.cardsWrapper}
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {items?.map((item, index) => (
                <ImpactPeriodCard
                  key={item.id}
                  item={item}
                  handleDelete={handleDelete(item.id)}
                  disableDragging={isLoading || !!filter.query}
                  index={index}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <AddImpactPeriodButton />
      <PaginationButtons buttonsOnly />
    </>
  )
}

export { ImpactPeriodsGrid }
